<template>
<div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>
    <v-dialog v-model="IBANDialog" persistent max-width="450"> 
        <v-dialog v-model="dialogsorIBAN" persistent max-width="290">
                    <v-card>
                        <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
                        <v-card-text> {{ $t('Are-you-sure-want-delete') }} </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="info" flat @click.native="dialogsorIBAN=false">{{$t("cancel_button")}}</v-btn>

                            <v-btn color="info" flat @click="IBANSil()">{{ $t('OK') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
<v-card>
    <v-card-title class="headline">{{ $t('IBAN-Info')}}</v-card-title>
    <v-card-text>
        <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-text-field  hide-details="" label="IBAN" v-model="guncelleIBAN.IBAN" maxlength="28">
                                </v-text-field>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <v-textarea  maxlenght="250" hide-details="" :label="$t('Description')" v-model="guncelleIBAN.Description">
                                </v-textarea>
                              </v-flex>
                            </v-layout>
    </v-card-text>
   
   
    <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="IBANDialog=false">{{ $t('cancel_button')}}</v-btn>
              <v-btn color="primary" flat @click="IBANGuncelle()"
                >{{ $t('save_button')}}</v-btn
              >
            </v-card-actions>
</v-card>
</v-dialog>
    <v-dialog v-if="videodialog" v-model="videodialog" max-width="800px">
        <v-card>
            <v-card-text>

                <iframe width="100%" height="500" src="https://www.youtube.com/embed/3Ve0qSD3R5c?list=PLIeHwLek0GOeIoIUwHSUXZpnvX2Al8l3g" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>

            </v-card-text>
        </v-card>
    </v-dialog>

    <v-card height="100%" color="grey lighten-5" flat>
        <v-form>
            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-toolbar class="baslik" size="120px" dark color="info">
                        <v-toolbar-title>{{this.$t('current_index_addbuton_label')}} </v-toolbar-title>
                        <v-spacer></v-spacer>


                           <v-checkbox :label="this.$t('Save-in-All-Companies')" class="justify-end" v-model="tumsirketler" hide-details>
                             </v-checkbox>                       
                        <v-tooltip bottom>
                            <v-btn :disabled="!sayfayetki.Save" slot="activator" v-on:click="counter += 1" flat> <span class="hidden-sm-and-down"> <span class="hidden-sm-and-down">{{$t('save_button')}}</span>
                                </span>
                                <v-icon right dark>add_box</v-icon>
                            </v-btn>

                            <span v-if="!sayfayetki.Save">{{ this.$t('Limited-Authorization') }}</span>
                            <span v-if="sayfayetki.Save">{{ this.$t('Add') }}</span>
                        </v-tooltip>

                        <v-menu bottom="">
                            <v-btn slot="activator" dark icon>
                                <v-icon>more_vert</v-icon>
                            </v-btn>

                            <v-list>
                                <a target="_self" v-bind:href="'#/cari/index/'">

                                    <v-list-tile>
                                        <v-list-tile-title>{{$t('cancel_button')}}</v-list-tile-title>
                                    </v-list-tile>
                                </a>
                            </v-list>
                            <v-list>

                                <v-list-tile @click="videoac()">
                                    <v-list-tile-title> {{ $t('How-to-do') }} </v-list-tile-title>
                                </v-list-tile>

                            </v-list>
                        </v-menu>

                    </v-toolbar>
                </v-flex>

                <v-tabs style="width:100%;" dark="" v-model="active" color="blue darken-3" slot="extension" slider->
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href='#0'>
                        {{$t("tab_general")}}
                    </v-tab>
                    <v-tab-item :id="'0'" style="width:100%; height:500px;">
                        <v-layout row="" wrap="">
                            <v-flex pa-1 xs12 sm6 md6>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout row wrap>

                                                <v-flex xs9 md9 sm9>
                                                    <v-text-field :label="$t('Currentcode_label')" @blur="checkCode()" maxlength="15" v-model="Current.Code" :error-messages="errors.collect('carikod')" v-validate="'required'" hide-details="" data-vv-name="carikod" required>
                                                      <template v-slot:prepend>
                                                        <v-icon color="info" @click="getCariDialog()">search</v-icon>
                                                      </template>
                                                    </v-text-field>

                                                </v-flex>
                                                <v-flex xs3 md3 sm3>
                                                    <v-layout row wrap justify-center align-center fill-height>
                                                        <v-btn outline @click="soncarikoduGetir()" color="info">{{ $t('View-Last-Current-Code') }}</v-btn>
                                                    </v-layout>
                                                </v-flex>
                                               

                                                <v-flex xs12 md12 sm12>
                                                    <v-text-field hide-details="" :label="$t('Title_label')" maxlength="100" v-model="Current.Title" :error-messages="errors.collect('unvan')" v-validate="'required'" data-vv-name="unvan" required>
                                                    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 md12 sm12>
                                                    <v-text-field hide-details="" :label="$t('Title_label') +  ' 2'" maxlength="100" v-model="Current.Title2">
                                                    </v-text-field>
                                                </v-flex>

                                                <v-flex xs12 md12 sm12>
                                                    <v-text-field hide-details="" :label="$t('Authorized_label')" value="" v-model="Current.Authorized">
                                                    </v-text-field>
                                                </v-flex>

                                                <v-flex xs12 md12 sm12>
                                                    <v-select :items="musteritipi" hide-details="" v-model="Current.CustomerType" item-text="text" item-value="value" clearable :label="$t('Customertype_label')">
                                                    </v-select>
                                                </v-flex>

                                                <v-flex xs12 md12 sm12>
                                                    <v-text-field hide-details="" :label="$t('Phonenumber_label')" maxlength="15" v-model="Current.Phone1">
                                                    </v-text-field>
                                                </v-flex>

                                                <v-flex xs12 md12 sm12>
                                                    <v-text-field hide-details="" :label="$t('Phonenumber_label')+'2'" maxlength="15" v-model="Current.Phone2">
                                                    </v-text-field>
                                                </v-flex>

                                                <v-flex xs12 md12 sm12>
                                                    <v-text-field hide-details="" autocomplete='postal-code' :label="$t('Mobilphonenumber_label')" maxlength="15" v-model="Current.Mobile"></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 md12 sm12>
                                                    <v-text-field hide-details="" :label="$t('Email_label')" v-model="Current.Email"></v-text-field>
                                                </v-flex>

                                                <v-flex xs12 md12 sm12>
                                                    <v-text-field hide-details="" :label="$t('Web-Address')" v-model="Current.Web"></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                            <v-flex pa-1 xs12 sm6 md6>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout justify-space-between column>
                                                <v-textarea v-model="Current.InfoNote" :label="$t('Infonote_label')"></v-textarea>
                                                <v-textarea v-model="Current.WarningNote" :label="$t('Warningnote_label')"></v-textarea>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
                        </v-layout>

                    </v-tab-item>

                    <v-tab href='#1' ripple>
                        {{ $t('tab_invoiceinformation') }}
                    </v-tab>

                    <v-tab-item :id="'1'" style="width:100%; height:100%;">
                        <v-layout row="" wrap="">
                            <v-flex pa-1 xs12 sm6 md4>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout justify-space-between column>

                                                <v-flex xs12 sm12 pt-1 pb-2 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{ $t('Billingaddressinformation_headers')}}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-text-field hide-details="" :label="$t('Taxcenter_label')" v-model="Current.Invoice.TaxOffice">
                                                </v-text-field>
                                                <v-layout align="center">
                                                    <v-flex xs8 sm8 md8>
                                                        <v-form ref="vergino" v-model="valid" lazy-validation>

                                                            <v-text-field hide-details="" :label="$t('Taxnumber_label')" v-model="Current.Invoice.TaxNumber"></v-text-field>
                                                        </v-form>
                                                    </v-flex>
                                                    <v-flex xs4 sm4 md4 v-if="PB=='TRY'">
                                                        <v-layout align="center" fill-height column justify-end>

                                                            <v-btn v-if="!mukellefScroll" small flat @click="mukellefSorgula()" color="info">
                                                                 {{ $t('Inquire-Liables') }} <v-icon>search</v-icon>
                                                            </v-btn>
                                                            <v-progress-linear v-if="mukellefScroll" color="red" indeterminate rounded height="6">
                                                            </v-progress-linear>

                                                        </v-layout>
                                                    </v-flex>

                                                </v-layout>
                                                <v-text-field hide-details="" :label="$t('Postcode_label')" v-model="Current.Invoice.PostCode">
                                                </v-text-field>
                                                 <v-combobox
          v-model="Current.Invoice.Country"
          :items="ulkeTipi"
          :label="$t('Country_label')"
        ></v-combobox>
                                                <!-- <v-text-field hide-details="" :label="$t('Country_label')" v-model="Current.Invoice.Country"></v-text-field> -->
                                                <v-text-field hide-details="" :label="$t('Province_label')" v-model="Current.Invoice.Province">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('BuildingNumber')" v-model="Current.Invoice.BuildingNumber" maxlength="5">  </v-text-field>
                                                <v-textarea hide-details="" no-resize v-model="Current.Invoice.Address" :label="$t('Address_label')">
                                                </v-textarea>
                                                 <v-text-field v-if="PB=='TRY'" hide-details="" :label="$t('Expense-Unit-VKN')" v-model="Current.Invoice.SpendingUnitVKN">
                                                </v-text-field>
                                                <v-checkbox :label="$t('Dontbebilled_label')" v-model="biletlerfaturalanmasin" hide-details>
                                                </v-checkbox>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>

                            </v-flex>

                            <v-flex pa-1 xs12 sm6 md4>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout justify-space-between column>

                                                <v-flex xs12 sm12 pt-1 pb-2 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{ $t('Foridentity_header') }}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-text-field hide-details="" :label="$t('Identitynumber_label')" value="" mask="###########" v-model="Current.Invoice.IdentityNumber"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('Name_label')" v-model="Current.Invoice.PerFirstName" required>
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Surname_label')" v-model="Current.Invoice.PerFamilyName" required>
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Title_label')" v-model="Current.Invoice.PerTitle" required>
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Othername_label')" v-model="Current.Invoice.PerMiddleName" required>
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Suffixname_label')" v-model="Current.Invoice.PerNameSuffix" required>
                                                </v-text-field>
                                                <v-text-field hide-details="" label="Passport Number" maxlength="9" v-model="Current.Invoice.PassportNumber" required>
                                                </v-text-field>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                            <v-flex pa-1 xs12 sm6 md4>
                                <v-card class="white--text" v-if="PB=='TRY'">
                                    <v-card flat="">
                                        <v-card-actions>

                                            <v-layout justify-space-between column >
                                                <v-flex xs12 sm12 pt-1 pb-2 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                   {{ $t('E-invoiceamenable_header') }}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-select hide-details="" :items="efaturatipi" v-model="Current.EInvoiceType" item-text="text" item-value="value" :label="$t('E-invoicetype')"></v-select>
                                                <v-text-field v-if="cokluposta==false" hide-details="" :label="$t('Post-Label')" v-model="Current.PostCodeLabel">
                                                </v-text-field>

                                                <v-select v-if="cokluposta==true" :items="postaitems" hide-details="" v-model="Current.PostCodeLabel" clearable :label="$t('Post-Label')">
                                                </v-select>

                                                <v-checkbox :label="$t('E-invoicetypeamenable_label')" v-model="efaturamukellefi" hide-details></v-checkbox>
                                                <v-checkbox :label="$t('Usingmultiplemail_label')" v-model="Current.MultiPostUse" hide-details>
                                                </v-checkbox>

                                                <v-flex xs12 pb-2 sm12 pt-4 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{$t('E-archiveinfo_header')}}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-select hide-details="" :items="islembilgileri" v-model="Current.EArchiveSendType" item-text="text" item-value="value" :label="$t('E-archiveprocessinformationtype_label')"></v-select>
                                                <v-checkbox :label="$t('Printonpaperinsteadofe-archive')" v-model="Current.EArchiveSendPaper" hide-details></v-checkbox>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-tab-item>

                    <v-tab href='#2' ripple>
                        {{ $t('Contract') }}
                    </v-tab>

                    <v-tab-item :id="'2'">
                        <v-layout row="" wrap="">

                            <v-flex pa-1 xs12 sm6 md4>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>

                                            <v-layout justify-space-between column>

                                                <v-flex xs12 sm12 pt-1 pb-2 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{$t('Definitions-v2')}}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-text-field hide-details="" :label="$t('Contract-No')" v-model="Current.Contract.ContractNumber" required>
                                                </v-text-field>

                                                <tarihim :etiket="$t('Contract-Commencement')" v-bind:value="date" :detaygizle="true" v-model="date" v-bind:defaultvalue="'no'"></tarihim>

                                                <parainput v-model="Current.CreditLimit" :simge="getparabirimi()" :etiket="$t('Credit-Limit')" :autocomplete="'autocomplete'"></parainput>
                                                <v-text-field hide-details="" :label="$t('Currency')" v-model="Current.CreditLimitCurrencyAmount">
                                                </v-text-field>
                                                <v-select hide-details="" :items="doviztipi" clearable item-text="DovizAdi" item-value="DovizKod" v-model="Current.CreditLimitCurrency" :label="$t('Currency-Unit')"></v-select>
                                                <v-text-field hide-details="" :label="$t('Payment-Method')" v-model="Current.Contract.PaymentType">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Bank-Account-No')" v-model="Current.Contract.BankAccountNumber"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('Bank-Branch-Code')" v-model="Current.Contract.BankBranchOffice"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('DOT9-Password')" v-model="Current.WebPassword"></v-text-field>
                                                <v-text-field hide-details="" autocomplete='postal-code' label="PIN Code" v-model="Current.PinCode"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('Mil-Code')" v-model="Current.MileCode"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('Bank')" v-model="Current.Bank"></v-text-field>

                                            </v-layout>

                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                            <v-flex pa-1 xs12 sm6 md4>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>

                                            <v-layout justify-space-between column>

                                                <v-flex xs12 sm12 pt-1 pb-2 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{ $t('Terms') }}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-btn color="info" @click.native="dialogfiltre=true" flat><span class="caption info--text font-weight-medium ">
                                                                {{ $t('Type-Explanations') }}
                                                            </span> &nbsp;<v-icon small color="info">help_outline</v-icon>
                                                            </v-btn>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-layout>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-text-field hide-details="" :label="$t('Domestic-Line')" v-model="Current.ExpiryDayDomestic">
                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-select :items="vadetipi" item-text="value" item-value="value" hide-details="" clearable v-model="Current.ExpiryTypeDomestic" :label="$t('Type')"></v-select>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-text-field hide-details="" :label="$t('International-Line')" v-model="Current.ExpiryDayInt">
                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-select :items="vadetipi" item-text="value" item-value="value" hide-details="" :label="$t('Type')" v-model="Current.ExpiryTypeInt" clearable></v-select>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-text-field hide-details="" :label="$t('tab_general')" type="Number" v-model="Current.ExpiryDayGeneral"></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-select :items="vadetipi" item-text="value" item-value="value" hide-details="" :label="$t('Type')" v-model="Current.ExpiryTypeGeneral" clearable></v-select>
                                                    </v-flex>
                                                </v-layout>

                                                <v-flex xs12 sm12 pb-2 pt-2 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{ $t('Discounts') }}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-text-field hide-details="" :label="$t('Domestic-Line')" v-model="Current.DiscountDom"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('International-Line')" v-model="Current.DiscountInt"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('Domestic-Service')" v-model="Current.DiscountDomService">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('International-Service')" v-model="Current.DiscountIntService">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('tab_general')" v-model="Current.DiscountGeneral"></v-text-field>

                                            </v-layout>

                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                            <v-flex pa-1 xs12 sm6 md4>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>

                                            <v-layout justify-space-between column>

                                                <v-flex xs12 sm12 pb-2 pt-1 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{ $t('Invoice-Articles') }}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-text-field hide-details="" type="Number" :label="$t('Number-of-Rows-in-Invoice')" value="" v-model="Current.Contract.InvoiceRowNumber"></v-text-field>
                                                <v-select :items="evethayir" hide-details="" clearable item-text="text" item-value="value" v-model="Current.Contract.InvoicePassengerName" :label="$t('Invoice-Passenger-Name')"></v-select>
                                                <v-select hide-details="" :items="evethayir" clearable item-text="text" item-value="value" v-model="Current.Contract.InvoiceFlightNumber" :label="$t('Invoice-Flight-No')"></v-select>
                                                <v-checkbox :label="$t('VAT-Exemption')" v-model="Kdvmuaf" hide-details></v-checkbox>
                                                <v-checkbox v-if="PB=='TRY'" :label="$t('Do-not-want-paper-print')" v-model="ciktiistemiyor" hide-details></v-checkbox>
                                                <v-checkbox v-if="PB=='TRY'" :label="$t('Let-Customer-Information-Appear-on-the-Invoice')" v-model="musteribilgitipi" hide-details></v-checkbox>
                                                <v-checkbox v-if="PB=='TRY'" :label="$t('Tevkifatlı')" v-model="Current.Contract.Tevkifatli" hide-details>
                                                </v-checkbox>
                                                <v-text-field v-if="PB=='TRY' && Current.Contract.Tevkifatli" v-model="Current.Contract.TevkifatKodu" label="Tevkifat kodu" hide-details />
                                                <v-select v-if="PB=='TRY' && Current.Contract.Tevkifatli" :items="tevkifatOranlari" v-model="Current.Contract.TevkifatOrani" item-text="text" item-value="value" label="Tevkifat oranı" hide-details clearable :rules="[v => !Current.Contract.Tevkifatli || (v !== null && v !== '') || 'Tevkifat oranı zorunlu']" :required="Current.Contract.Tevkifatli"></v-select>
                                                <v-checkbox :label="$t('İade Cari Ayrılsın')" v-model="Current.Contract.IadeCariAyrilsin" hide-details></v-checkbox>
                                               <!-- <cariaracomp v-if="Current.Contract.IadeCariAyrilsin" :etiket="$t('İade Cari')" :loading="loading" v-bind:value="Current.Contract.IadeCariKod" v-model="Current.Contract.IadeCariKod"></cariaracomp>-->
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                        </v-layout>
                    </v-tab-item>

                    <v-tab href='#3' ripple>
                        {{$t('Service-Fee')}}
                    </v-tab>

                    <v-tab-item :id="'3'">

                        <v-layout row="" wrap>
                            <v-flex pa-1 xs12 sm12 md6>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout row="" wrap justify-start="" fill-height="">

                                                <v-flex xs12 sm12 pt-1 pb-2 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{ $t('Domestic-Line-Service-Fees') }}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 sm8 md8>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="red" label>
                                                                            <span class="white--text">11-</span>
                                                                        </v-chip>
                                                                        <v-checkbox disabled="" v-model="ServisParametre.checkIc"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm4 md4>
                                                                    <parainput v-model="ServisParametre.Fiyat11" :id="'Fiyat11'" :etiket="$t('Low-Cost-Price')" :simge="getparabirimi()" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete id="doviz11" v-model="ServisParametre.Doviztip11" hide-details="" disabled="" :items="doviztipi" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>

                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="red" label>
                                                                            <span class="white--text"> 12- </span>
                                                                        </v-chip>
                                                                        <v-checkbox disabled="" v-model="ServisParametre.checkIc"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm4 md4>
                                                                    <parainput :etiket="$t('Eco-Cost-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat12" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" disabled="" v-model="ServisParametre.Doviztip12" :items="doviztipi" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>

                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="red" label>
                                                                            <span class="white--text"> 13-</span>
                                                                        </v-chip>
                                                                        <v-checkbox disabled="" v-model="ServisParametre.checkIc"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm4 md4>
                                                                    <parainput :etiket="$t('Business-Cost-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat13" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" disabled="" :items="doviztipi" v-model="ServisParametre.Doviztip13" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="red" label>
                                                                            <span class="white--text"> 15- </span>
                                                                        </v-chip>
                                                                        <v-checkbox disabled="" v-model="ServisParametre.checkIc"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm4 md4>
                                                                    <parainput :etiket="$t('Return-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat15" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" disabled="" :items="doviztipi" v-model="ServisParametre.Doviztip15" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>

                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="red" label>
                                                                            <span class="white--text caption"> 19-</span>
                                                                        </v-chip>
                                                                        <v-checkbox disabled="" v-model="ServisParametre.checkIc"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm4 md4>
                                                                    <parainput :etiket="$t('Internal-Reservation-Change-Fee')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat19" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" disabled="" :items="doviztipi" v-model="ServisParametre.Doviztip19" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 sm4 md4>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-checkbox v-model="icYuzdedenHesapla.Yuzdeden" :label="$t('Domestic-Lines-Calculation')" hide-details>
                                                            </v-checkbox>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-select hide-details="" v-if="icyuzde" v-model="icYuzdedenHesapla.HesapTipi" :items="hesaptipi" item-text="text" item-value="value" :label="$t('Account-Type')"></v-select>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <yuzdeinput :etiket="$t('Percentage') + '%'" v-if="icyuzde" v-model="icYuzdedenHesapla.HesapYuzde" :autocomplete="'autocomplete'"></yuzdeinput>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                            <v-flex pa-1 xs12 sm12 md6>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout row="" wrap justify-start="" fill-height="">
                                                <v-flex xs12 pb-2 sm12 pt-1 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{$t('International-Lines-Service-Prices')}}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 sm6 md8>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="info" label>
                                                                            <span class="white--text"> 21-</span>
                                                                        </v-chip>
                                                                        <v-checkbox disabled="" v-model="ServisParametre.checkIc"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <parainput :etiket="$t('International-Short-Cost-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat21" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip21" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>

                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="info" label>
                                                                            <span class="white--text"> 22- </span>
                                                                        </v-chip>
                                                                        <v-checkbox disabled="" v-model="ServisParametre.checkIc"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <parainput :etiket="$t('International-Short-Business-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat22" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md5>
                                                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip22" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>

                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="info" label>
                                                                            <span class="white--text"> 31-</span>
                                                                        </v-chip>
                                                                        <v-checkbox disabled="" v-model="ServisParametre.checkIc"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <parainput :etiket="$t('International-Long-Eco-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat31" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip31" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="info" label>
                                                                            <span class="white--text"> 32-</span>
                                                                        </v-chip>
                                                                        <v-checkbox disabled="" v-model="ServisParametre.checkIc"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <parainput :etiket="$t('International-Long-Business-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat32" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip32" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>

                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="info" label>
                                                                            <span class="white--text caption"> 33-</span>
                                                                        </v-chip>
                                                                        <v-checkbox disabled="" v-model="ServisParametre.checkIc"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <parainput :etiket="$t('First-Class-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat33" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip33" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="info" label>
                                                                            <span class="white--text caption"> 40-</span>
                                                                        </v-chip>
                                                                        <v-checkbox disabled="" v-model="ServisParametre.checkIc"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <parainput :etiket="$t('International-Return-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat40" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip40" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')">
                                                                    </v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="info" label>
                                                                            <span class="white--text caption"> 44-</span>
                                                                        </v-chip>
                                                                        <v-checkbox disabled="" v-model="ServisParametre.checkIc"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <parainput :etiket="$t('International-Reservation-Change-Fee')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat44" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip44" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 sm4 md4>
                                                    <v-layout align-content-start="" fill-height="" row wrap>
                                                        <v-flex xs12 sm6 md12>
                                                            <v-checkbox v-model="DisYuzdedenHesapla.Yuzdeden" :label="$t('International-Line-Calculation')" hide-details></v-checkbox>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md12>
                                                            <v-select hide-details="" v-if="disyuzde" v-model="DisYuzdedenHesapla.HesapTipi" :items="hesaptipi" item-text="text" item-value="value" :label="$t('Account-Type')"></v-select>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md12>
                                                            <yuzdeinput :etiket="$t('Percentage') + '%'" v-if="disyuzde" v-model="DisYuzdedenHesapla.HesapYuzde" :autocomplete="'autocomplete'"></yuzdeinput>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-tab-item>

                    <v-tab href='#4' ripple>
                       {{$t('Other')}}
                    </v-tab>

                    <v-tab-item :id="'4'">
                        <v-layout row="" wrap="">
                            <v-flex pa-1 xs12 sm12 md6>
                                <v-card>
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout justify-space-between column>
                                                <muhasebekoducomp v-if="PB=='TRY'" :etiket="$t('Accounting-Code')" maxlength="25" v-model="Current.AccountingCode" :readonly="accounting" :hint="$t('Arama Butonu ile Seçim Yapabilirsiniz')"></muhasebekoducomp>
                                                <v-text-field hide-details="" :label="$t('Export-current-code')" v-model="Current.ExternalCurrentCode">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Export-accounting-code')" v-model="Current.ExternalAccountingCode">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Transfer-Current-Code')" v-model="Current.StreamCurrentCode">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Arkman-Transfer-Code')" v-model="Current.ArkmanStreamCode">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Arkman-Transfer-Password')" v-model="Current.ArkmanStreamPassword">
                                                </v-text-field>
                                                <v-text-field hide-details="" name="input-3-3" v-model="Current.Invoice.DeliveryAddress" :label="$t('Delivery-Address')"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('Name-Delivery')" v-model="Current.Invoice.DeliveryName">
                                                </v-text-field>
                                                <v-autocomplete :items="masrafmerkezi" hide-details="" clearable item-text="Title" item-value="Code" v-model="Current.ExpenseCenter" class="text-xs" :label="$t('Expense-Center-v2')">
                                                </v-autocomplete>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                            <v-flex pa-1 xs12 sm12 md6>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout justify-space-between column>
                                                <v-select hide-details="" clearable v-model="Current.TemplateID" :label="$t('Template-Selection-Profile')">
                                                </v-select>

                                                <cariaracomp v-bind:etiket="$t('Main-Account')" :loading="loading" v-bind:value="Current.MainAccount" v-model="Current.MainAccount"></cariaracomp>

                                                <v-autocomplete hide-details clearable :items="hesapgurubu" v-model="Current.AccountGroup" :label="$t('Account-Group')" item-text="Title" item-value="Kod" max-height="400">
                                                </v-autocomplete>

                                                <v-select v-if="PB=='TRY'" hide-details="" clearable :label="$t('CM-Code')" :items="cmkodu" v-model="Current.CMCode">
                                                </v-select>

                                                <analizcomp :etiket="$t('Analysis-Code')" v-model="Current.AnalysisCode"></analizcomp>
                                                 <v-layout justify-space-between row>

                                                <v-flex xs12 sm6 md6 v-if="PB=='TRY'">
                                                
                                                 <v-text-field hide-details="" :label="$t('Special-Code') + ' 5'" v-model="Current.PrivateCode5">
                                                </v-text-field>
                                                
                                                <v-text-field hide-details="" :label="$t('Special-Code') + ' 6'" v-model="Current.PrivateCode6">
                                                </v-text-field>
                                                
                                                <v-checkbox :label="$t('Periodic-Code')" v-model="Current.PeriodControl" hide-details></v-checkbox>

                                                </v-flex>
                                               <v-flex xs12 sm6 md6 v-if="PB=='TRY'">
                                                
                                                <v-text-field hide-details="" :label="$t('Special-Code') + ' 7'" v-model="Current.PrivateCode7">
                                                </v-text-field>
                                                
                                                <v-text-field hide-details="" :label="$t('Special-Code') + ' 8'" v-model="Current.PrivateCode8">
                                                </v-text-field>  

                                                 <v-checkbox :label="$t('Profile-Mandatory')" v-model="profilzorunlu" hide-details></v-checkbox>
                                                <v-checkbox :label="$t('EventID-Mandatory')" v-model="eventidzorunlu" hide-details></v-checkbox>
                                                </v-flex>
                                                 </v-layout>
                       
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-tab-item>

                    <v-tab href='#5' ripple>
                        {{$t('Notes')}}
                    </v-tab>
                    <v-tab-item :id="'5'">
                        <v-flex pa-1 xs12 sm12 md12>
                            <v-card class="white--text">
                                <v-card flat="">
                                    <v-card-actions>

                                        <v-layout row="" wrap="">
                                            <v-flex xs12 sm12 md12>

                                                <v-layout justify-space-between column>
                                                    <v-textarea hide-details="" v-model="Current.Explanations" :label="$t('Notes')"></v-textarea>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                        </v-flex>
                    </v-tab-item>

                    
                     <v-tab href='#6' @click="sablonGetir()" ripple>
                      {{ $t('Templates') }}  
                    </v-tab>
                    <v-tab-item :id="'6'">
                       <v-flex pa-2 xs12 sm12 md12>
                           <v-layout row wrap>
                           <v-flex xs12 sm6 md6 pr-2>
                               <v-card>
                                   <v-card-title primary-title>
                                    {{ $t('Templates') }}  
                                   </v-card-title>
                                   <v-card-text v-if="itemsSablon.length > 0">
                                    <v-layout row wrap align-center justify-center v-for="item in itemsSablon" :key="item.id">
                                      
                                       <v-flex xs11 sm11 md11>
                                           {{item.ad}}
                                       </v-flex>
                                          <v-flex xs2 sm2 md1>
                                        <v-btn icon ripple>
                                            <v-icon @click="ItemAktar(item,1)" color="green">
                                            arrow_forward_ios
                                            </v-icon>
                                        </v-btn>
                                       </v-flex>
                                    
                                      </v-layout>
                                   </v-card-text>
                               </v-card>
                           </v-flex>
                            <v-flex xs12 sm6 md6 pl-2>
                                 <v-card>
                                   <v-card-title primary-title>
                                    {{ $t('Selected-Templates') }}  
                                   </v-card-title>
                                     <v-card-text v-if="itemsSablonSelected.length > 0">
                                        <v-layout row wrap align-center justify-center v-for="item in itemsSablonSelected" :key="item.id">
                                         <v-flex xs2 sm2 md1>
                                        <v-btn icon ripple>
                                            <v-icon @click="ItemAktar(item,2)" color="red">
                                            arrow_back_ios
                                            </v-icon>
                                        </v-btn>
                                       </v-flex>
                                       <v-flex xs11 sm11 md11>
                                           {{item.ad}}
                                       </v-flex>
                                    
                                      </v-layout>
                                   </v-card-text>
                               </v-card>
                           </v-flex>
                           </v-layout>
                         
                                
                        </v-flex>
                    </v-tab-item> 
                    <v-tab href='#8'  ripple>
                       {{$t('Bank-Info')}}
                    </v-tab>
                    <v-tab-item :id="'8'">
                        <v-form ref="formbanka" v-model="validbanka" lazy-validation>

<v-flex pa-1 xs12 sm12 md12>
    <v-card class="white--text">
        <v-card flat="">
            <v-card-actions>
                <v-layout row="" wrap="">

                    <v-flex xs12 pt-2 pb-2 sm12 md12>
                        <v-card flat>
                            <v-layout pa-2 row="" wrap="">
                                <v-flex xs12 sm12 md12>
                                    <span class=" font-weight-regular grey--text subheading"> {{ $t('IBAN') }} </span>
                                    <v-divider></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md3>
                                    <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="IBANAd" label="IBAN" 
                                        maxlength="28"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm13 md3>
                                    <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="IBANDesc" :label="this.$t('Description')"></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm4 md1>
                                    <v-layout align-center fill-height>
                                        <v-btn  color="info" @click="IBANEkle()">
                                          {{this.$t('Add-IBAN')}}</v-btn>
                                       
                                    </v-layout>
                                </v-flex>
                             

                            </v-layout>
                        </v-card>
                    </v-flex>

                    <v-flex xs12 pt-2 pb-2 sm12 md12>
                        <v-card flat>
                            <v-layout pa-2 row="" wrap="">
                                <v-flex xs12 pt-2 pb-2 sm12 md12>
                                    <span class=" font-weight-regular grey--text subheading">
                                        {{ $t('IBAN-LIST') }}
                                    </span>
                                    <v-divider></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-card flat>
                                        <v-data-table :headers="headersbankinfo" :items="Current.BankInfo" hide-actions class="elevation-1">
                                            <template slot="items" slot-scope="props">
                                                <tr item v-if="props.item.Silinecek==false">
                                                    <td class="text-xs-left">{{ props.item.IBAN}}</td>
                                                    <td class="text-xs-left">{{ props.item.Description}}</td>
                                                    <td class="text-xs-right">
                                                        <v-btn icon>
                                                            <v-icon @click="IBANGuncelleAc(props.item)" color="teal">edit</v-icon>
                                                        </v-btn>
                                                        <v-btn @click="IBANSilSor(props.item)" icon>
                                                            <v-icon color="red">delete</v-icon>
                                                        </v-btn>
                                                    </td>

                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-card>

                                </v-flex>
                            
                            </v-layout>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-card>

</v-flex>
</v-form>
                    </v-tab-item> 
                    <v-tab v-if="PB=='TRY'" href='#9'  ripple>
                       MÜŞTERİ PERSONEL GİRİŞİ
                    </v-tab>
                    <v-tab-item :id="'9'">
  <v-layout row wrap>
    <v-flex xs12>   
      <v-card>
        <v-card-text>
          <v-form>
            <v-layout row wrap>

              <v-flex xs12 sm6>
                <v-text-field :label="$t('Currentcode_label')" @blur="checkCode()" maxlength="15" v-show="false" v-model="Current.Code" :error-messages="errors.collect('carikod')" v-validate="'required'" hide-details data-vv-name="carikod" required><template v-slot:prepend><v-icon color="info" @click="getCariDialog()">search</v-icon></template></v-text-field>
                <v-text-field label="Şirket Kodu" v-model="MusteriPersonel.SirketKodu"></v-text-field>
                <v-text-field label="Masraf Yeri" v-model="MusteriPersonel.MasrafYeri"></v-text-field>
                <v-text-field label="Sicil No" v-model="MusteriPersonel.SicilNo"></v-text-field>
                <v-text-field label="Ad" v-model="MusteriPersonel.Adi"></v-text-field>
                <v-text-field label="Soyad" v-model="MusteriPersonel.Soyadi"></v-text-field>
                <v-text-field label="Çalışma Yeri" v-model="MusteriPersonel.CalismaYeri"></v-text-field>
                <v-text-field label="Bölüm" v-model="MusteriPersonel.Bolum"></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field label="İç Seyahat" v-model="MusteriPersonel.IcSeyahat"></v-text-field>
                <v-text-field label="International Travel" v-model="MusteriPersonel.DisSeyahat"></v-text-field>
                <v-text-field label="İş Alanı" v-model="MusteriPersonel.IsAlanı"></v-text-field>
                <v-text-field label="Sipariş" v-model="MusteriPersonel.Siparis"></v-text-field>
                <v-text-field label="Email" v-model="MusteriPersonel.Email"></v-text-field>
                <v-text-field label="Telefon" v-model="MusteriPersonel.Tel"></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-checkbox label="Müşteri/Personel Açık" v-model="MusteriPersonel.KapatAc"></v-checkbox>
              </v-flex>

            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-tab-item>

                </v-tabs>

                
                <v-dialog v-model="CariDialog" scrollable="" max-width="500px">
                    <v-card flat color="grey lighten-5">

                        <v-card-title>   {{ $t('Find-Current') }} </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>

                            <v-flex xs12 sm12 md12>
                                <v-card>
                                    <v-card-title>
                                        <v-text-field
                                            append-icon="search"
                                            label="Search"
                                            single-line
                                            hide-details
                                            v-model="cariSearch"
                                        ></v-text-field>
                                    </v-card-title>
                                    <v-data-table
                                        :headers="headers"
                                        :items="cariItems"
                                        :search="cariSearch"
                                    >
                                        <template slot="items" slot-scope="props">
                                            <tr @click="selectCari(props.item.Code)">
                                                <td class="text-xs-left">{{ props.item.Code }}</td>
                                            </tr>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            Your search for "{{ cariSearch }}" found no results.
                                        </v-alert>
                                    </v-data-table>
                                </v-card>
                            </v-flex>

                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click.native="CariDialog=false">{{$t('Close')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>


                <v-dialog v-model="dialogfiltre" scrollable="" max-width="500px">
                    <v-card flat color="grey lighten-5">

                        <v-card-title> {{ $t('Term-Type-Explanations') }} </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>

                            <v-flex xs12 sm12 md12>
                                <v-list two-line>
                                    <template v-for="(item, index) in vadetipi">
                                        <v-subheader v-if="item.header" :key="item.header">

                                        </v-subheader>

                                        <v-divider v-else-if="item.divider" :key="index" :inset="item.inset"></v-divider>

                                        <v-list-tile v-else :key="item.title">
                                            <v-list-tile-avatar>
                                                {{item.value}}
                                            </v-list-tile-avatar>

                                            <v-list-tile-content>
                                                <span class="caption"> {{item.text}}</span>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                </v-list>

                            </v-flex>

                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click.native="dialogfiltre=false">{{$t('Close')}}</v-btn>

                        </v-card-actions>
                    </v-card>
                </v-dialog>
                
            </v-layout>
        </v-form>

    </v-card>
</div>
</template>

<script>
import auth from '../../../api/auth'
import parainput from '../customcomp/parainput'
import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
import tarihim from "@/components/app/customcomp/tarihim.vue"
import tool from "../coper/tools";
import helpers from "@/components/app/customcomp/helpers.js"
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import cariaracomp from '@/components/app/customcomp/cariaracomp'
import analizcomp from '@/components/app/bilet/partpage/analizcomp'
import loadingcomp from "@/components/app/customcomp/loadingcomp"
import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp'
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";


export default {
    data() {
        return {
            tevkifatOranlari: Array.from({ length: 11 }, (_, i) => ({
        text: `${i}/10`,
        value: i / 10, 
      })),
MusteriPersonel: {
      ID: '',
      SirketKodu: '',
      SirketAdi: '',
      MasrafYeri: '',
      SicilNo: '',
      Adi: '',
      Soyadi: '',
      CalismaYeri: '',
      Bolum: '',
      IcSeyahat: '',
      DisSeyahat: '',
      IsAlani: '',
      Siparis: '',
      Cari: {
        Kod: ''
      },
      KapatAc: false,
      Email: '',
      Tel: ''
    },
            validbanka:true,
            guncelleIBAN:{
IBAN:'',
Description:'',
Silinecek:false
            },
            IBANAdGuncelle:'',
            IBANDescGuncelle:'',
            IBANDialog:false,
            IBANAd:'',
            IBANDesc:'',
            PB:"TRY",
            dialogsorIBAN:false,
headersbankinfo:[
{
     text: this.$t('IBAN'),
                    value: 'IBAN'
},
{
                    text: this.$t('Description'),
                    value: 'Description'
                },
],
            headers:[
                {
                    text:"Kod"
                }
            ],
            tumsirketler:false,
            currentCheck:{},
            sablonSelectedItem:{
                design:[]
            },
            accounting:false,
            sablonData:null,
            ulkeTipi:[],
            itemsSablon:[],
            itemsSablonSelected:[],
            counter: 0,
            loadingvmodel: false,
            videodialog: false,
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0,
            },

            prevRoute: null,

            mukellefScroll: false,
            hesapgurubu: [],
            dialogfiltre: false,
            cokluposta: false,
            postaitems: [],
            valid: true,
            tabcontrol3: 0,
            drawer: null,
            baslik: '',
            e1: 0,
            Code: '',
            e2: true,
            yok: false,
            statecari: [],
            search: '',
            search1: '',
            loading: false,
            Current: {
                AliciSatici:0,
                CompanyCode: '',
                Code: null,
                Title: null,
                Title2: null,
                Phone1: '',
                Phone2: '',
                Mobile: '',
                Web: '',
                Email: '',
                AccountGroup: '',
                Type: '',
                CMCode: '',
                Reserved1: '',
                Reserved2: '',
                Authorized: '',
                WarningNote: '',
                InfoNote: '',
                AccountingCode: '',
                CustomerType: '',
                TicketBill: '',
                EInvoiceType: '0',
                PostCodeLabel: '',
                EInvoiceCustomer: '',
                MultiPostUse: false,
                EArchiveSendType: 'true',
                EArchiveSendPaper: false,
                CreditLimit: 0,
                CreditLimitCurrencyAmount: 0,
                CreditLimitCurrency: '',
                WebPassword: '',
                PinCode: '',
                MileCode: '',
                Bank:'',
                ExpiryDayDomestic: '',
                ExpiryTypeDomestic: '',
                ExpiryDayInt: '',
                ExpiryTypeInt: '',
                ExpiryDayGeneral: '',
                ExpiryTypeGeneral: '',
                DiscountGeneral: '',
                DiscountDom: '',
                DiscountInt: '',
                DiscountDomService: '',
                DiscountIntService: '',
                TaxFree: '',
                ExternalCurrentCode: '',
                ExternalAccountingCode: '',
                StreamCurrentCode: '',
                ArkmanStreamCode: '',
                ArkmanStreamPassword: null,
                ExpenseCenter: null,
                TemplateID: '',
                ProfileForced: '',
                EventIDForced: '',
                MainAccount: '',
                Explanations: null,
                AnalysisCode: null,
                PrivateCode5:null,
                PrivateCode6:null,
                PrivateCode7:null,
                PrivateCode8:null,
                PeriodControl:false,
                BankInfo:[],
                CustomReportTemplate:[],
                Invoice: {
                    SpendingUnitVKN:'',
                    Address: '',
                    PostCode: '',
                    Province: '',
                    Country: '',
                    TaxNumber: '',
                    TaxOffice: '',
                    IdentityNumber: '',
                    PerFirstName: '',
                    PerFamilyName: '',
                    PerTitle: '',
                    PerMiddleName: '',
                    PerNameSuffix: '',
                    NoPrint: '',
                    CustomerPersonelNoInvoice: '',
                    DeliveryAddress: '',
                    DeliveryName: '',
                    BuildingNumber:''
                },
                Contract: {
                    ContractNumber: '',
                    ContractDate: '',
                    PaymentType: '',
                    BankAccountNumber: '',
                    BankBranchOffice: '',
                    InvoiceRowNumber: '',
                    InvoicePassengerName: '',
                    InvoiceFlightNumber: '',
                    IadeCariAyrilsin: false,
                    IadeCariKod: ''
                }
            },
            ServisParametreYedek: {

                ServisKod11: 11,
                Doviztip11: null,
                Fiyat11: 0,

                ServisKod12: 12,
                Doviztip12: null,
                Fiyat12: 0,

                ServisKod13: 13,
                Doviztip13: null,
                Fiyat13: 0,

                ServisKod15: 15,
                Doviztip15: null,
                Fiyat15: 0,

                ServisKod19: 19,
                Doviztip19: null,
                Fiyat19: 0,

                ServisKod21: 21,
                Doviztip21: null,
                Fiyat21: 0,

                ServisKod22: 22,
                Doviztip22: null,
                Fiyat22: 0,

                ServisKod31: 31,
                Doviztip31: null,
                Fiyat31: 0,

                ServisKod32: 32,
                Doviztip32: null,
                Fiyat32: 0,

                ServisKod33: 33,
                Doviztip33: null,
                Fiyat33: 0,

                ServisKod40: 40,
                Doviztip40: null,
                Fiyat40: 0,

                ServisKod44: 44,
                Doviztip44: null,
                Fiyat44: 0,

            },
            ServisParametre: {
                checkIc: false,
                checkDis: false,
                ServisKod11: 11,
                Doviztip11: null,
                Fiyat11: 0,
                check11: false,

                ServisKod12: 12,
                Doviztip12: null,
                Fiyat12: 0,
                check12: false,

                ServisKod13: 13,
                Doviztip13: null,
                check13: false,
                Fiyat13: 0,

                ServisKod15: 15,
                Doviztip15: null,
                Fiyat15: 0,
                check15: false,

                ServisKod19: 19,
                Doviztip19: null,
                Fiyat19: 0,
                check15: false,

                ServisKod21: 21,
                Doviztip21: null,
                Fiyat21: 10,
                check21: false,

                ServisKod22: 22,
                Doviztip22: null,
                Fiyat22: 0,
                check22: false,

                ServisKod31: 31,
                Doviztip31: null,
                Fiyat31: 0,
                check31: false,

                ServisKod32: 32,
                Doviztip32: null,
                Fiyat32: 0,
                check32: false,

                ServisKod33: 33,
                Doviztip33: null,
                Fiyat33: 0,
                check33: false,

                ServisKod40: 40,
                Doviztip40: null,
                Fiyat40: 0,
                check40: false,

                ServisKod44: 44,
                Doviztip44: null,
                Fiyat44: 0,
                check44: false,

            },

            hesaptipi: [{
                    text: this.$t('Ticket-Amount'),
                    value: 0
                },
                {
                    text: this.$t('Ticket-Amount') + '+'+ this.$t('Taxes'),
                    value: 1
                }
            ],

            icYuzdedenHesapla: {
                Yuzdeden: false,
                HesapTipi: null,
                HesapYuzde: 0
            },
            DisYuzdedenHesapla: {
                Yuzdeden: false,
                HesapTipi: null,
                HesapYuzde: 0
            },
  caritipi: [{
                    text: this.$t('Buyer-and-Seller'),
                    value: 0
                },
                {
                    text: this.$t('Buyer'),
                    value: 1
                }, {
                    text: this.$t('Seller'),
                    value: 2
                },

            ],
            musteritipi: [{
                    text: this.$t('Individual'),
                    value: 'B'
                },
                {
                    text: this.$t('Corporate'),
                    value: 'K'
                }, {
                    text: this.$t('Public'),
                    value: 'D'
                },

            ],
            efaturatipi: [{
                    text: this.$t('Commercial'),
                    value: '0'
                },
                {
                    text: this.$t('Basic'),
                    value: '1'
                },
                {
                    text: this.$t('Export'),
                    value: '2'
                },  {
                    text: this.$t('Public'),
                    value: '3'
                }
            ],
            islembilgileri: [{
                    text: this.$t('Hard-Copy-Invoice'),
                    value: 'false'
                },
                {
                    text: this.$t('Electronic-Invoice'),
                    value: 'true'
                }
            ],
            cmkodu: [
                'C', 'M'
            ],
            doviztipi: [],

            vadetipi: [{
                    value: 'D',
                    text: this.$t('transfer-date-lesser-than-transfer-date-day')

                },

                {
                    value: 'D+',
                    text: this.$t('transfer-date-lesser-transfer-date-greater-day')

                },

                {
                    value: 'D-',
                    text: this.$t('transfer-date-lesser-transfer-date-greater-day')
                },
                {
                    value: 'E',
                    text: this.$t('transfer-date-lesser-day-next-month-greater')
                },
                {
                    value: 'E+',
                    text: this.$t('day-the-first-month-number-entered-days')
                },
                {
                    value: 'E-',
                    text: this.$t('first-month-number-entered-days')
                },

                {
                    value: 'K',
                    text: this.$t('day-first-month')
                },
                {
                    value: 'K+',
                    text: this.$t('month-number-entered-days')
                },
                {
                    value: 'K-',
                    text: this.$t('month-number-entered-days-minus')
                },
                {
                    value: 'L',
                    text: this.$t('day-first-month-twenty')
                }, {
                    value: 'L-',
                    text: this.$t('the-first-month-number-entered-days')
                }, {
                    value: 'L+',
                    text: this.$t('first-month-number-entered-days-v2')
                }, {
                    value: 'M',
                    text: this.$t('day-of-the-first-month')
                }, {
                    value: 'M+',
                    text: this.$t('first-month-number-entered-days-v3')
                }, {
                    value: 'M-',
                    text: this.$t('first-month-number-entered-days-v4')
                },
                {
                    value: 'R',
                    text: this.$t('day-of-if-the-transfer')
                },
                {
                    value: 'R+',
                    text: this.$t('entered-days-date-lesser-than-day')
                },
                {
                    value: 'R-',
                    text: this.$t('entered-days-date-lesser-than-day')
                }, {
                    value: 'S',
                    text: this.$t('transfer-date-lesser-dayday')
                }, {
                    value: 'S+',
                    text: this.$t('number-date-lesser-than-day')
                }, {
                    value: 'S-',
                    text: this.$t('number-date-lesser-than-day')
                }, {
                    value: 'V',
                    text: this.$t('day-of-the-next-month')
                }, {
                    value: 'V+',
                    text: this.$t('next-month-number-entered-days')
                }, {
                    value: 'V-',
                    text: this.$t('next-month-number-entered-days-v2')
                }
            ],
            evethayir: [{
                    text: this.$t('Yes'),
                    value: 'E'
                },
                {
                    text: this.$t('No-v2'),
                    value: 'H'
                },
            ],
            masrafmerkezi: [],

            autocomplete: 'autocomplete',
            tutar: 'tutar',
            etikettutar: 'Tutar',
            defaultvalue: 0,
            nameRules: [
                (v) => v && v.length <= 25 || 'max 25 karakter'
            ],

            emailRules: [
                (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail formatı uygun değil'
            ],

            dictionary: {
                custom: {
                    carikod: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },
                    unvan: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },

                }
            },

            StartDate: null,
            EndDate: null,
            NumberOfPolicies: '',
            PolicySum: '',
            TotalDebt: '',
            TotalFlatDebt: '',
            kaydetbuton: false,

            date: null,
            menu: false,
            modal: false,
            dateFormatted: '',
            text1: '',
            ichatdoviztipi1: false,
            ichatdoviztipi2: false,
            ichatdoviztipi3: false,
            ichatdoviztipi4: false,
            ichatdoviztipi5: false,
            dishatdoviztipi1: false,
            dishatdoviztipi2: false,
            dishatdoviztipi3: false,
            dishatdoviztipi4: false,
            dishatdoviztipi5: false,
            dishatdoviztipi6: false,
            dishatdoviztipi7: false,
            biletlerfaturalanmasin: null,
            efaturamukellefi: false,
            Kdvmuaf: null,
            ciktiistemiyor: null,
            musteribilgitipi: null,
            profilzorunlu: null,
            eventidzorunlu: null,
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            carikod: '',
            unvan: '',
            active: '',
            ex11: 'false',
            CariDialog:false,
            cariSearch:null,
            icyuzde: false,
            disyuzde: false,
            cariItems:[]
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from.path
        })
    },
    created() {
    this.Current = this.Current || {};
    this.Current.Contract = this.Current.Contract || {};
    if (this.Current.Contract.Tevkifatli === undefined)
      this.$set(this.Current.Contract, "Tevkifatli", false);
    if (this.Current.Contract.TevkifatOrani === undefined)
      this.$set(this.Current.Contract, "TevkifatOrani", null);
      if (this.Current.Contract.TevkifatKodu === undefined)
      this.$set(this.Current.Contract, "TevkifatKodu", "");

      if (this.Current.Contract.IadeCariAyrilsin === undefined)
  this.$set(this.Current.Contract, "IadeCariAyrilsin", false);

if (this.Current.Contract.IadeCariKod === undefined)
  this.$set(this.Current.Contract, "IadeCariKod", "");

  },

    mounted() {
        this.$validator.localize('en', this.dictionary)
        
        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

        if (this.sayfayetki.Status == true) {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            this.PB=credentials.ParaBirimi;
            this.accounting=JSON.parse(window.localStorage.getItem('nextMuhasebe'));
            
            this.getSirketParameters();
 tool.http_post(this, "UlkeList", {}).then(
    (response) => {
      if (response.body.Status == true) {
        response.body.data.forEach((element) => {
           this.ulkeTipi.push(element.Isim);
          });
      } else {
        this.text1 = "Service Unavailable-country";
        this.snackbar = true;
      }
    },
    (response) => {
      this.text1 = "Service Unavailable";
      this.snackbar = true;
    }
  );
            var params = {
                CompanyCode: credentials.SirketKodu
            }

            this.$http.post(auth.API_URL + 'api/currency/List', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.doviztipi = response.body
            }, (response) => {
                 if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })

            this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.hesapgurubu = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })

            this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.masrafmerkezi = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })

        } else {

            this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

                if (sonuc == true) {

                    if (this.prevRoute != null) {
                        var url = '#' + this.prevRoute

                        window.open(url, '_self')
                    } else {
                        var mainUrl = '#/'
                        window.open(mainUrl, '_self')
                    }
                } 

            });

        }

    },
    methods: {
        IBANGuncelle()
        {
            this.IBANDialog=false;
        },
        IBANGuncelleAc(item)
        {
            this.guncelleIBAN=item;
            this.IBANDialog=true;
         
        },
        IBANEkle()
        {
            if (this.$refs.formbanka.validate())
        {
            var bankinfoekle={
            IBAN:this.IBANAd,
            Description:this.IBANDesc,
            Silinecek:false
          }
          this.Current.BankInfo.push(bankinfoekle);
        }
        
        },
        IBANSilSor(item) {
            this.dialogsorIBAN = true;
            this.silinecekIBAN=item;
        },
        IBANSil() {
            this.silinecekIBAN.Silinecek=true;
            this.dialogsorIBAN = false;
            
        },
        getSirketParameters(){
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params = {
          SirketKodu: credentials.SirketKodu
        }
        this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
                  
          this.Current.EInvoiceType = String(response.body.VarsayilanEfaturaTip)

        }, (response) => {
                  this.loadingvmodel=false

          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true

          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })

      
},
        selectCari(val){
            this.Current.Code = val;
            this.CariDialog = false;
        },
        sortAlphaNum(a, b) {
        var reA = /[^a-zA-Z]/g;
        var reN = /[^0-9]/g;
        var aA = a.replace(reA, "");
        var bA = b.replace(reA, "");
        if (aA === bA) {
            var aN = parseInt(a.replace(reN, ""), 10);
            var bN = parseInt(b.replace(reN, ""), 10);
            return aN === bN ? 0 : aN > bN ? 1 : -1;
        } else {
            return aA > bA ? 1 : -1;
        }
        },
        getCariDialog(){
            if(this.Current.Code != null && this.Current.Code != ""){
                this.CariDialog = true;
                this.cariItems = [];
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var current = {
                    CompanyCode: credentials.SirketKodu,
                    Text: this.Current.Code,
                }

                this.$http.post(auth.API_URL + 'api/Helpers/GetLastCurrentList', current, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    if(response.body.length > 0){
                        response.body.reverse().forEach(element => {
                            this.cariItems.push(element);
                        });


                    }
                }, (response) => {
                    this.text1 = this.$t('The-code-could-not-be-fetched-try-again')
                    this.snackbar = true

                })

            }else{
                this.text1 = this.$t('Account-Code-Field-Cannot-be-Empty')
                    this.snackbar = true
            }
            
        },
        applyCode(val){
              this.Current = val
                this.Current.EInvoiceType = String(val.EInvoiceType)
                this.Current.EInvoiceCustomer = String(val.EInvoiceCustomer)
                this.Current.EArchiveSendType = String(val.EArchiveSendType)
                this.Current.ProfileForced = String(val.ProfileForced)
                this.Current.EventIDForced = String(val.EventIDForced)

                if (val.CreditLimit == "" || val.CreditLimit == null) {
                    this.Current.CreditLimit = 0
                } else {
                    this.Current.CreditLimit = parseFloat(val.CreditLimit)
                }
                this.Current.MainAccount = val.MainAccount

                this.date = val.Contract.ContractDate

                if (val.TicketBill == '1') {
                    this.biletlerfaturalanmasin = true
                } else {
                    this.biletlerfaturalanmasin = false
                }

                if (val.EInvoiceCustomer == '1') {

                    this.efaturamukellefi = true
                } else {
                    this.efaturamukellefi = false
                }

                if (val.Invoice.NoPrint == '1') {

                    this.ciktiistemiyor = true
                } else {
                    this.ciktiistemiyor = false
                }

                if (val.TaxFree == '1') {
                    this.Kdvmuaf = true
                } else {
                    this.Kdvmuaf = false
                }

                if (val.ProfileForced == '1') {

                    this.profilzorunlu = true
                } else {
                    this.profilzorunlu = false
                }

                if (val.EventIDForced == '1') {

                    this.eventidzorunlu = true
                } else {
                    this.eventidzorunlu = false
                }

                if (val.Invoice.CustomerPersonelNoInvoice == '1') {

                    this.musteribilgitipi = true
                } else {
                    this.musteribilgitipi = false
                }
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var prm = {
                    SirketKodu: credentials.SirketKodu,
                    CariKodu: val.Code
                }

                this.$http.post(auth.API_URL + 'api/Current/CurrentAirlineStreamList', prm, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.aktarimitems = response.body
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })
        },
        checkCode(){
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var CurrentInput = {
                Code: this.Current.Code,
                CompanyCode: credentials.SirketKodu
            }
            this.$http.post(auth.API_URL + 'api/Current/Get', CurrentInput, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                if(response.body.Title != null){
                    this.checkDialog = true;
                    this.applyCode(response.body);
                }

            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = response.body.StatusText
                    this.snackbar = true
                }
            })








        },
        ItemAktar(value,key){
            switch (key) {
                case 1:
                    var indexAdd = this.itemsSablon.indexOf(value);
                    this.itemsSablon.splice(indexAdd,1);
                    this.itemsSablonSelected.push(value);
                    break;
                case 2:
                    var indexDelete = this.itemsSablonSelected.indexOf(value);
                    this.itemsSablonSelected.splice(indexDelete,1);
                    this.itemsSablon.push(value);
                    break;
            
                default:
                    break;
            }
        },
      parseDesign() {
        if (this.sablonSelectedItem.design.length > 0) {

          var temp = JSON.parse(this.sablonSelectedItem.design);
          var r = [];
          var i;
          for (i = 0; i < temp.length; i++) {
            if (temp[i].selected) {
              r.push(temp[i]);
            }
          }
          return r;

        } else {
          return []
        }
      },
    sablonShow(sablonData){
        this.sablonSelectedItem.design = sablonData.design;
    },
    sablonGetir() {
        if(this.itemsSablonSelected.length <= 0 && this.itemsSablon.length <= 0){
        
        tool.api_post(this, "RaporSablon/GetReportBroDesignGrupAll", {
            id: 0,
            ad: 'GenelAmacli',
            objectName: 'Models.GenelAmacliClass'
          })
          .then(
            response => {
              this.itemsSablon = response.body;
            },
            (response) => {
                this.text1 = 'Sablon getirilemedi, tekrar deneyiniz.'
                this.snackbar = true

            }
          );
        }
      },
        videoac() {
            this.videodialog = true
        },
        HataYonetimi(response, request, baslik) {
            this.mukellefScroll = false
            if (response.status === 500) {
                //Internal Server Error
                this.$refs.hatadialog.open(response, request, baslik);
            } else {
                this.text1 = "Service Unavailable -" + baslik;
                this.snackbar = true;
            }
        },
        soncarikoduGetir() {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var current = {
                CompanyCode: credentials.SirketKodu,
                Text: this.Current.Code
            }

            this.$http.post(auth.API_URL + 'api/Helpers/GetLastCurrent', current, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                this.Current.Code = response.body
            }, (response) => {
                this.text1 = 'Kod getirilemedi, tekrar deneyiniz.'
                this.snackbar = true

            })

        },
        getparabirimi() {
            return helpers.getparabirimi()
        },
        mukellefSorgula() {
            if (this.Current.Invoice.TaxNumber.length > 1) {
                this.mukellefScroll = true

                let prm = {
                    VKN: this.Current.Invoice.TaxNumber //9240492097
                }
                
                tool.api_post(this, "EFatura/VKN_Sorgula3", prm).then(

                    response => {
                        this.mukellefScroll = false

                        this.postaitems = []
                        if (response.body.Status == true) {

                        if (response.body.data.length > 0) {
                            this.efaturamukellefi = true

                            if (response.body.data.length > 1) {

                                this.cokluposta = true
                                response.body.data.forEach(element => {
                                    this.postaitems.push(element.alias)
                                });
                                this.Current.PostCodeLabel = response.body.data[0].alias
                            } else {
                                this.cokluposta = false
                                this.Current.PostCodeLabel = response.body.data[0].alias

                            }

                        } else {
                            this.text1 = this.$t('No-liable-found')
                            this.snackbar = true
                        }
                        } else {
                           this.text1 = response.body.ErrorList[0];
                           this.snackbar = true;
                        }

                    },
                    response => {
                        this.HataYonetimi(response, prm, 'Mükellef Sorgulanamadı');
                    }
                );

            } else {
                if(this.Current.Invoice.IdentityNumber.length == 11){
                    this.mukellefScroll = true

                    let prm = {
                        VKN: this.Current.Invoice.IdentityNumber
                    }

                    tool.api_post(this, "EFatura/VKN_Sorgula3", prm).then(

                        response => {
                            this.mukellefScroll = false

                            this.postaitems = []

                              if (response.body.Status == true) {
                                if (response.body.data.length > 0) {
                                this.efaturamukellefi = true

                                if (response.body.data.length > 1) {

                                    this.cokluposta = true
                                    response.body.data.forEach(element => {
                                        this.postaitems.push(element.alias)
                                    });
                                    this.Current.PostCodeLabel = response.body.data[0].alias
                                } else {
                                    this.cokluposta = false
                                    this.Current.PostCodeLabel = response.body.data[0].alias

                                }

                            } else {
                                this.text1 = this.$t('No-liable-found')
                                this.snackbar = true
                            } 
                            } else {
                                  this.text1 = response.body.ErrorList[0];
                                  this.snackbar = true;
                              }

      

                        },
                        response => {
                            this.HataYonetimi(response, prm, 'Mükellef Sorgulanamadı');
                        }
                    );

                }else if(this.Current.Invoice.IdentityNumber.length != 11){
                   this.text1 =this.$t('Please-enter-your-ID-number-or-tax-number.')
                   this.snackbar = true
                }else{
                this.text1 = this.$t('Please-Enter-Your-Digit-Taxation-Number')
                this.snackbar = true
                }

            }

        },
        ekle: ekle,
        getDateNow: getDateNow,
        onChangecheck: onChangecheck,
        onChangecheckdis: onChangecheckdis,
        karsidegeral: karsidegeral
    },
    beforeMount: beforeMount,
    components: {
        'parainput': parainput,
        yuzdeinput,
        tarihim,
        yetkidialog,
        hatadialog,
        cariaracomp,
        analizcomp,
        loadingcomp,
        muhasebekoducomp,
        snackbarcomp
    },
    watch: {
       "Current.Contract.Tevkifatli"(val) {
  if (!val) {
    this.Current.Contract.TevkifatOrani = null;
    this.Current.Contract.TevkifatKodu = "";
  }
},
"Current.Contract.IadeCariAyrilsin"(val) {
    if (!val) this.Current.Contract.IadeCariKod = "";
  },
        'counter': function () {
            if (this.counter == 1) {
                this.ekle()
            }
        },
        'icYuzdedenHesapla.Yuzdeden': function (value) {
            if (value == true) {
                this.icyuzde = true
                this.icYuzdedenHesapla.HesapTipi = 0
            } else {
                this.icyuzde = false
                this.icYuzdedenHesapla.HesapTipi = null
            }
        },
        'DisYuzdedenHesapla.Yuzdeden': function (value) {
            if (value == true) {
                this.disyuzde = true
                this.DisYuzdedenHesapla.HesapTipi = 0
            } else {
                this.disyuzde = false
                this.DisYuzdedenHesapla.HesapTipi = null
            }
        }
    }
}

function karsidegeral(val) {
    if (val == true) {
        return false
    } else if (val == false) {
        return false
    }
}

function onChangecheck(elem1, elem2) {

    var nerden = document.getElementsByName(elem2)[0].attributes.name.value
    if (this.ichatdoviztipi1 == true && nerden != 'ichatdoviztipi1') {
        this.ichatdoviztipi1 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi2 === true && nerden != 'ichatdoviztipi2') {
        this.ichatdoviztipi2 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi3 === true && nerden != 'ichatdoviztipi3') {
        this.ichatdoviztipi3 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi4 === true && nerden != 'ichatdoviztipi4') {
        this.ichatdoviztipi4 = karsidegeral(elem1)
    }
    if (this.ichatdoviztipi5 === true && nerden != 'ichatdoviztipi5') {
        this.ichatdoviztipi5 = karsidegeral(elem1)
    }
}

function onChangecheckdis(elem1, elem2) {

    var nerden = document.getElementsByName(elem2)[0].attributes.name.value
    if (this.dishatdoviztipi1 == true && nerden != 'dishatdoviztipi1') {
        this.dishatdoviztipi1 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi2 === true && nerden != 'dishatdoviztipi2') {
        this.dishatdoviztipi2 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi3 === true && nerden != 'dishatdoviztipi3') {
        this.dishatdoviztipi3 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi4 === true && nerden != 'dishatdoviztipi4') {
        this.dishatdoviztipi4 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi5 === true && nerden != 'dishatdoviztipi5') {
        this.dishatdoviztipi5 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi6 === true && nerden != 'dishatdoviztipi6') {
        this.dishatdoviztipi6 = karsidegeral(elem1)
    }
    if (this.dishatdoviztipi7 === true && nerden != 'dishatdoviztipi7') {
        this.dishatdoviztipi7 = karsidegeral(elem1)
    }
}

function beforeMount() {

}

function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
        dd = '0' + dd
    }

    if (mm < 10) {
        mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
}

function ekle() {
    if (this.counter == 1) {

        this.$validator.validateAll().then((result) => {
            if (result) {
                 var selectedItems = new Array();

                this.itemsSablonSelected.forEach(element => {
                    var item = {
                        TemplateId : element.id,
                        TemplateName : element.ad
                    };
                    selectedItems.push(item);
                });

                this.Current.CustomReportTemplate = selectedItems;


                this.loadingvmodel = true
                if (this.biletlerfaturalanmasin == true) {
                    this.Current.TicketBill = '1'
                } else {
                    this.Current.TicketBill = '0'
                }

                if (this.efaturamukellefi == true) {
                    this.Current.EInvoiceCustomer = '1'
                } else {
                    this.Current.EInvoiceCustomer = '0'
                }

                if (this.ciktiistemiyor == true) {
                    this.Current.Invoice.NoPrint = '1'
                } else {
                    this.Current.Invoice.NoPrint = '0'
                }

                if (this.date != null || this.date != '') {
                    this.Current.Contract.ContractDate = new Date(this.date)
                }

                if (this.Kdvmuaf == true) {
                    this.Current.TaxFree = '1'
                } else {
                    this.Current.TaxFree = '0'
                }

                if (this.profilzorunlu == true) {
                    this.Current.ProfileForced = '1'
                } else {
                    this.Current.ProfileForced = '0'
                }
                if (this.eventidzorunlu == true) {
                    this.Current.EventIDForced = '1'
                } else {
                    this.Current.EventIDForced = '0'
                }

                if (this.musteribilgitipi === true) {
                    this.Current.Invoice.CustomerPersonelNoInvoice = '1'
                } else {
                    this.Current.Invoice.CustomerPersonelNoInvoice = '0'
                }
  if (this.Current.AliciSatici == null) {
                    this.Current.AliciSatici = 0
                } 
                 var credentials = JSON.parse(window.localStorage.getItem('credentials'));


                if(this.tumsirketler === true){
                    this.Current.CompanyCode = 0
                }else{
                    this.Current.CompanyCode = credentials.SirketKodu
                }
 if (this.Current.AliciSatici == null) {
                    this.Current.AliciSatici = 0
                } 
                if (this.Current.Contract.Tevkifatli) {
  if (this.Current.Contract.TevkifatOrani == null) {
    this.text1 = "Tevkifat oranı zorunlu";
    this.snackbar = true;
    this.counter = 0; this.loadingvmodel = false;
    return;
  }
  if (!this.Current.Contract.TevkifatKodu || !this.Current.Contract.TevkifatKodu.trim()) {
    this.text1 = "Tevkifat kodu zorunlu";
    this.snackbar = true;
    this.counter = 0; this.loadingvmodel = false;
    return;
  }
}
if (!this.Current.Contract.IadeCariAyrilsin) {
  this.Current.Contract.IadeCariKod = "";
}
//if (this.Current.Contract.IadeCariAyrilsin === true) {
  //if (!this.Current.Contract.IadeCariKod || !this.Current.Contract.IadeCariKod.trim()) {
    //this.text1 = "İade cari zorunlu";
    //this.snackbar = true;
    //this.counter = 0;
    //this.loadingvmodel = false;
    //return;
  //}
//}


                var current = this.Current

                this.$http.post(auth.API_URL + 'api/Current/New', current, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    
                    if (response.body.Status === true) {
                         this.text1 = this.$t(response.body.ResponseMessage)
                         this.MusteriPersonel.Cari.Kod = this.Current.Code;

                    

            
if (
    
      this.MusteriPersonel.SirketKodu &&
      this.MusteriPersonel.MasrafYeri &&
      this.MusteriPersonel.SicilNo
    ) {
        
      this.$http.post(auth.API_URL + 'api/Extra/CustomerPersonnelAdd', this.MusteriPersonel, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }  
      });
    }
                     
                        this.snackbar = true
                        this.Current.Code = null;
                        this.Current.Title = null;
                        this.Kdvmuaf = false;
                        this.ciktiistemiyor = false;
                        this.musteribilgitipi = false;
                        this.profilzorunlu = false;
                        this.eventidzorunlu = false;
                        this.Current.Phone1 = null;
                        this.Current.Phone2 = null;
                        this.Current.Mobile = null;
                        this.Current.Web = null;
                        this.Current.Email = null;
                        this.Current.AccountGroup = null;
                        this.Current.Type = null;
                        this.Current.CMCode = null;
                        this.Current.Reserved1 = null;
                        this.Current.Reserved2 = null;
                        this.Current.Authorized = null;
                        this.Current.WarningNote = null;
                        this.Current.InfoNote = null;
                        this.Current.CustomerType = null;
                        this.Current.TicketBill = null;
                        this.Current.EInvoiceType = '0';
                        this.Current.PostCodeLabel = null;
                        this.Current.EInvoiceCustomer = null;
                        this.Current.MultiPostUse = false;
                        this.Current.EArchiveSendType = false;
                        this.Current.EArchiveSendPaper = false;
                        this.Current.CreditLimit = null;
                        this.Current.CreditLimitCurrencyAmount = null;
                        this.Current.CreditLimitCurrency = null;
                        this.Current.WebPassword = null;
                        this.Current.PinCode = null;
                        this.Current.MileCode = null;
                        this.Current.Bank =null;
                        this.Current.ExpiryDayDomestic = null;
                        this.Current.ExpiryTypeDomestic = null;
                        this.Current.ExpiryDayInt = null;
                        this.Current.ExpiryTypeInt = null;
                        this.Current.ExpiryDayGeneral = null;
                        this.Current.ExpiryTypeGeneral = null;
                        this.Current.DiscountGeneral = null;
                        this.Current.DiscountDom = 0;
                        this.Current.DiscountInt = 0;
                        this.Current.Explanations = null;
                        this.Current.AnalysisCode = null;
                        this.efaturamukellefi = false;
                        this.Current.DiscountDomService = 0;
                        this.Current.DiscountIntService = 0;
                        this.Current.TaxFree = 0;
                        this.Current.ExternalCurrentCode = null;
                        this.Current.ExternalAccountingCode = null;
                        this.Current.StreamCurrentCode = null;
                        this.Current.ArkmanStreamCode = null;
                        this.Current.ArkmanStreamPassword = null;
                        this.Current.ExpenseCenter = null;
                        this.Current.TemplateID = null;
                        this.Current.ProfileForced = null;
                        this.Current.EventIDForced = null;
                        this.Current.MainAccount = null;
                        this.Current.Invoice.Address = null;
                        this.Current.Invoice.PostCode = null;
                        this.Current.Invoice.Province = null;
                        this.Current.Invoice.Country = null;
                        this.Current.Invoice.TaxNumber = null;
                        this.Current.Invoice.TaxOffice = null;
                        this.Current.Invoice.IdentityNumber = null;
                        this.Current.Invoice.PerFirstName = null;
                        this.Current.Invoice.PerFamilyName = null;
                        this.Current.Invoice.PerTitle = null;
                        this.Current.Invoice.PerMiddleName = null;
                        this.Current.Invoice.PerNameSuffix = null;
                        this.Current.Invoice.NoPrint = null;
                        this.Current.Invoice.CustomerPersonelNoInvoice = null;
                        this.Current.Invoice.DeliveryAddress = null;
                        this.Current.Invoice.DeliveryName = null;
                        this.Current.Contract.ContractNumber = null;
                        this.Current.Contract.ContractDate = null;
                        this.Current.Contract.PaymentType = null;
                        this.Current.Contract.BankAccountNumber = null;
                        this.Current.Contract.BankBranchOffice = null;
                        this.Current.Contract.InvoiceRowNumber = null;
                        this.Current.Contract.InvoicePassengerName = null;
                        this.Current.Contract.InvoiceFlightNumber = null;
                        this.counter = 0
                        this.loadingvmodel = false
                    } else if (response.body.Status === false) {
                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true
                        this.counter = 0
                        this.loadingvmodel = false

                    }
                }, (response) => {
                    if (response.status === 0) {
                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true
                        this.counter = 0
                        this.loadingvmodel = false

                    } else {
                        this.counter = 0
                        this.loadingvmodel = false
                        let data ={
                        response: response,
                        request: current,
                        api:'Current/New',
                        type:2,
                        message: response.body.ExceptionMessage
                        };
                        this.$refs.showMessage.open(data);
                    }
                })
            } else {
                this.active = 0;
                this.counter = 0;
                this.loadingvmodel = false

            }
        })
    }
}
</script>

<style>
</style>
